import React, { useReducer } from 'react'

import AddressVerificationModal from '~/components/address-verification-modal'

import AddressVerificationContext from './address-verification-context'
import { addressVerificationReducer } from './address-verification.reducer'
import {
  performAddressVerification,
  setAddress,
} from './address-verification.utils'

import type { ReactNode } from 'react'
import type { Address } from '~/types'

export function AddressVerificationProvider({
  children,
  updateAddress,
  onSuccess,
  onError,
}: {
  children: ReactNode
  updateAddress: (address: Address) => Promise<boolean> | boolean
  onSuccess: (address: Address) => any
  onError: () => any
}) {
  const [state, dispatch] = useReducer(addressVerificationReducer, {
    verifying: false,
    originalAddress: undefined,
    verificationStatus: undefined,
    changedFields: undefined,
    suggestedAddress: undefined,
    isValid: undefined,
    lastValidatedAt: undefined,
    displayModal: false,
  })

  const value = {
    state,
    verifyAddress: (profileId: string, address: Address) =>
      performAddressVerification({
        profileId,
        dispatch,
        address,
        updateAddress,
        onSuccess,
        onError,
      }),
    acceptOriginalAddress: () => {
      if (!state.originalAddress) return

      const address = { ...state.originalAddress, isValid: !!state.isValid }
      if (state.lastValidatedAt) address.lastValidatedAt = state.lastValidatedAt

      setAddress({
        address,
        dispatch,
        updateAddress,
        onSuccess,
        onError,
      })
    },
    acceptSuggestedAddress: () => {
      if (!state.suggestedAddress) return

      setAddress({
        address: state.suggestedAddress,
        dispatch,
        updateAddress,
        onSuccess,
        onError,
      })
    },
    reenterAddress: () => {
      dispatch({
        type: 'verify_flow_finish',
      })
    },
  }

  return (
    <AddressVerificationContext.Provider value={value}>
      <AddressVerificationModal {...value} />
      {children}
    </AddressVerificationContext.Provider>
  )
}
